import styled from "styled-components";

export const Header = styled.h2`
  color: #24272a;
  font-size: 28px;
  font-family: "OpenSans-Regular", "Open Sans", sans-serif;
  font-weight: 400;
  word-wrap: break-word;
`;

export const Description = styled.div`
  width: 100%;
  color: #243e5e;
  font-size: 14px;
  font-family: "OpenSans-Regular", "Open Sans", sans-serif;
  font-weight: 400;
  line-height: 27px;
  word-wrap: break-word;
  margin: 26px 0;
`;

export const PageWrapper = styled.div``;
